/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import Box from '@mui/material/Box';
import { utils } from '@rjsf/core';
import { DateTimePicker } from '../../stories/DateTimePicker';
import { CustomWidgetProps } from '../types';
const { localToUTC, utcToLocal, getDisplayLabel } = utils;
const DateTimeWidget: React.FC<React.PropsWithChildren<CustomWidgetProps>> = ({
  id,
  readonly: readOnly,
  disabled,
  label,
  value,
  onChange,
  autofocus,
  schema,
  uiSchema,
  formContext: { onHasChanged },
}: CustomWidgetProps) => {
  const _value = utcToLocal(value);
  const _onChange = (nextValue: string) => {
    // DateTimePicker only emits '' (explicit clear) or a valid YYYY-MM-DD HH:mm string.
    onChange(nextValue ? localToUTC(nextValue) : undefined);
  };
  const _onHasChanged = (newValue: string, oldValue: string) => {
    // newValue is DateTimePicker's plain 'YYYY-MM-DD HH:mm'; oldValue is utcToLocal's
    // 'YYYY-MM-DDTHH:mm:ss.SSS' — align formats to minute precision before comparing.
    const oldDateTimeOnly = oldValue ? `${oldValue.slice(0, 10)} ${oldValue.slice(11, 16)}` : '';
    if (newValue !== oldDateTimeOnly) onHasChanged?.({ id, value: newValue });
  };
  const displayLabel = getDisplayLabel(schema, uiSchema);
  const accessibleLabel = displayLabel ? label || schema.title || '' : '';
  return (
    <Box data-testid="datetime-widget">
      <DateTimePicker
        className="datetime-widget"
        label={accessibleLabel}
        value={_value || null}
        onChange={(nextValue: string | null) => {
          const committed = nextValue || '';
          _onChange(committed);
          onHasChanged && setTimeout(() => _onHasChanged(committed, _value || ''), 0);
        }}
        disabled={disabled}
        readOnly={readOnly}
        slotProps={{
          textField: {
            autoFocus: autofocus,
            'aria-label': accessibleLabel,
          },
        }}
        sx={{
          '&.datetime-widget': {
            border: '1px solid #D5D7DA',
            borderRadius: '8px',
            // Outer border owns the outline — suppress MUI fieldset (avoids a stray rectangle
            // to the left of the calendar icon when a date section is focused).
            '& fieldset': {
              border: 'none',
            },
          },
        }}
      />
    </Box>
  );
};
export default DateTimeWidget;
